"use client";

import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-6 w-16 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="relative py-2 text-sm font-medium uppercase tracking-wider text-foreground transition-colors hover:text-primary after:absolute after:bottom-0 after:left-1/2 after:h-[2px] after:w-0 after:-translate-x-1/2 after:bg-primary after:transition-all after:duration-300 hover:after:w-full font-sans">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section data-section-id="252713" id="header" className="sticky top-0 z-50 w-full bg-background text-foreground transition-all duration-500 bg-background/80 backdrop-blur-md border-b border-border/10 shadow-sm min-h-[120px] md:!h-[250px]">
      <div className="container mx-auto px-2.5 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between py-8 md:py-0 md:!h-[225px]">
          <div className="flex shrink-0 items-center justify-center w-full md:w-auto">
            <Link to="/" className="flex items-center gap-2">
              <WvcLogo className="w-[188px] ![padding:0px_0px_188px_0px] [&_svg]:w-[188px] [&_svg]:![padding:0px_0px_188px_0px]" />
            </Link>
          </div>

          <div className="hidden md:flex flex-1 items-center justify-center px-8">
            <MenuProvider menu_id="69">
              <HeaderNav />
            </MenuProvider>
          </div>

          <div className="flex shrink-0 items-center justify-center w-full md:w-auto mt-6 md:mt-0">
            <Link to="/ContactPage">
              <Button className="bg-primary text-primary-foreground font-sans text-xs uppercase tracking-widest hover:bg-primary/90 hover:scale-105 transition-all duration-300 shadow-md hover:shadow-lg rounded-md">Book Today</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}